/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  AhBidRequest,
  AhGetListingsParams,
  AhScanTriggerRequest,
  ApiEnvelopeAhBidListResponse,
  ApiEnvelopeAhBidResponse,
  ApiEnvelopeAhListingDto,
  ApiEnvelopeAhListingsResponse,
  ApiEnvelopeAhScanTriggerResponse,
  ApiEnvelopeAhSnapshotsResponse,
  ApiEnvelopeAhStatsDto
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type ahGetStatsResponse200 = {
  data: ApiEnvelopeAhStatsDto
  status: 200
}

export type ahGetStatsResponseSuccess = (ahGetStatsResponse200) & {
  headers: Headers;
};
;

export type ahGetStatsResponse = (ahGetStatsResponseSuccess)

export const getAhGetStatsUrl = () => {




  return `/api/Ah/stats`
}

export const useAhGetStatsHook = (): ( options?: RequestInit) => Promise<ahGetStatsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getAhGetStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type ahGetListingsResponse200 = {
  data: ApiEnvelopeAhListingsResponse
  status: 200
}

export type ahGetListingsResponseSuccess = (ahGetListingsResponse200) & {
  headers: Headers;
};
;

export type ahGetListingsResponse = (ahGetListingsResponseSuccess)

export const getAhGetListingsUrl = (params?: AhGetListingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Ah/listings?${stringifiedParams}` : `/api/Ah/listings`
}

export const useAhGetListingsHook = (): (params?: AhGetListingsParams, options?: RequestInit) => Promise<ahGetListingsResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: AhGetListingsParams, options?: RequestInit) => {

        return customFetcher(getAhGetListingsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type ahGetListingResponse200 = {
  data: ApiEnvelopeAhListingDto
  status: 200
}

export type ahGetListingResponseSuccess = (ahGetListingResponse200) & {
  headers: Headers;
};
;

export type ahGetListingResponse = (ahGetListingResponseSuccess)

export const getAhGetListingUrl = (id: string,) => {




  return `/api/Ah/listings/${id}`
}

export const useAhGetListingHook = (): (id: string, options?: RequestInit) => Promise<ahGetListingResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getAhGetListingUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type ahGetSnapshotsResponse200 = {
  data: ApiEnvelopeAhSnapshotsResponse
  status: 200
}

export type ahGetSnapshotsResponseSuccess = (ahGetSnapshotsResponse200) & {
  headers: Headers;
};
;

export type ahGetSnapshotsResponse = (ahGetSnapshotsResponseSuccess)

export const getAhGetSnapshotsUrl = (id: string,) => {




  return `/api/Ah/listings/${id}/snapshots`
}

export const useAhGetSnapshotsHook = (): (id: string, options?: RequestInit) => Promise<ahGetSnapshotsResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getAhGetSnapshotsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type ahTriggerScanResponse200 = {
  data: ApiEnvelopeAhScanTriggerResponse
  status: 200
}

export type ahTriggerScanResponseSuccess = (ahTriggerScanResponse200) & {
  headers: Headers;
};
;

export type ahTriggerScanResponse = (ahTriggerScanResponseSuccess)

export const getAhTriggerScanUrl = () => {




  return `/api/Ah/scan`
}

export const useAhTriggerScanHook = (): (ahScanTriggerRequest?: AhScanTriggerRequest, options?: RequestInit) => Promise<ahTriggerScanResponse> => {

      const customFetcher = useSfetchMutator();
      return (ahScanTriggerRequest?: AhScanTriggerRequest, options?: RequestInit) => {

        return customFetcher(getAhTriggerScanUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ahScanTriggerRequest)
  }
);
      }
  }


export type ahPlaceBidResponse200 = {
  data: ApiEnvelopeAhBidResponse
  status: 200
}

export type ahPlaceBidResponseSuccess = (ahPlaceBidResponse200) & {
  headers: Headers;
};
;

export type ahPlaceBidResponse = (ahPlaceBidResponseSuccess)

export const getAhPlaceBidUrl = () => {




  return `/api/Ah/bid`
}

export const useAhPlaceBidHook = (): (ahBidRequest?: AhBidRequest, options?: RequestInit) => Promise<ahPlaceBidResponse> => {

      const customFetcher = useSfetchMutator();
      return (ahBidRequest?: AhBidRequest, options?: RequestInit) => {

        return customFetcher(getAhPlaceBidUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ahBidRequest)
  }
);
      }
  }


export type ahGetBidsResponse200 = {
  data: ApiEnvelopeAhBidListResponse
  status: 200
}

export type ahGetBidsResponseSuccess = (ahGetBidsResponse200) & {
  headers: Headers;
};
;

export type ahGetBidsResponse = (ahGetBidsResponseSuccess)

export const getAhGetBidsUrl = () => {




  return `/api/Ah/bids`
}

export const useAhGetBidsHook = (): ( options?: RequestInit) => Promise<ahGetBidsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getAhGetBidsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


